import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PowerSupplyMoveErrorDialog } from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';
import { fromEvent, merge, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { UploadDialog } from '../../common/message-dialog/upload-dialog';
import { PowerSupplyEditComponent } from '../power-supply-edit/power-supply-edit.component';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'nwt-power-supply-name-dialog',
  template:
  `
   <div *ngIf="confirmremovePic">
  <h1 mat-dialog-title>Are you Sure you want to remove Images ?</h1>
  <mat-dialog-actions class="d-flex justify-content-center">
    <button mat-button type="button" (click)="noremovePicture()">No</button>
    <button mat-button (click)="yesremovePicture()">Yes</button>
  </mat-dialog-actions>
  </div>

  <div *ngIf="deleteFlag">
  <h1 mat-dialog-title>Are you Sure you want to Delete Cache storage Images and upload new Images ?</h1>
  <mat-dialog-actions class="d-flex justify-content-center">
    <button mat-button type="button" (click)="noNewPicture()">No</button>
    <button mat-button (click)="yesNewPicture()">Yes</button>
  </mat-dialog-actions>
  </div>

  <div *ngIf="oldFlag">
  <h1 mat-dialog-title *ngIf="internetstatus"><b>Network Status: </b><b style="color:green">{{ onlineMessage }}!!</b></h1>
  <h1 mat-dialog-title *ngIf="!internetstatus"><b>Network Status: </b><b style="color:red">{{ onlineMessage }}!!</b></h1>

  <div *ngIf = "!internetstatus || localStorageFlag">
    <div><label for="min"><b>Category 1:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,1,'')"  #file_uploadOne>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadOne.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadOne.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat1 != null) ? cat1['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat1 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(1)">Submit
     </button></div>
     </div><br>

    <div><label for="min"><b>Category 2:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,2,'')"  #file_uploadTwo>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadTwo.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadTwo.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat2 != null) ? cat2['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat2 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(2)">Submit
     </button></div>
     </div><br>



    <div><label for="min"><b>Category 3:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,3,'')"  #file_uploadThree>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadThree.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadThree.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat3 != null) ? cat3['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat3 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(3)">Submit
     </button></div>
     </div><br>


    <div><label for="min"><b>Category 4:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,4,'')"  #file_uploadFour>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadFour.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadFour.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat4 != null) ? cat4['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat4 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(4)">Submit
     </button></div>
     </div><br>


    <div><label for="min"><b>Category 5:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,5,'')"  #file_uploadFive>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadFive.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadFive.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat5 != null) ? cat5['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat5 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(5)">Submit
     </button></div>
     </div><br>

    <div><label for="min"><b>Category 6:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,6,'')"  #file_uploadSix>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadSix.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadSix.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat6 != null) ? cat6['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat6 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(6)">Submit
     </button></div>
     </div><br>

    <div><label for="min"><b>Category 7:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,7,'')"  #file_uploadSeven>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadSeven.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadSeven.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat7 != null) ? cat7['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat7 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(7)">Submit
     </button></div>
     </div><br>

    <div><label for="min"><b>Category 8:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,8,'')"  #file_uploadEight>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadEight.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadEight.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat8 != null) ? cat8['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat8 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(8)">Submit
     </button></div>
     </div><br>


    <div><label for="min"><b>Category 9:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,9,'')"  #file_uploadNine>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadNine.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadNine.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat9 != null) ? cat9['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat9 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(9)">Submit
     </button></div>
     </div><br>

    <div><label for="min"><b>Category 10:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,10,'')"  #file_uploadTen>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadTen.click()" src="../../../assets/upload.png" class="uploadIcon">-->
    <mat-label class="imageNav" (click)="file_uploadTen.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat10 != null) ? cat10['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat10 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(10)">Submit
     </button></div>
     </div><br>

    <div><label for="min"><b>Category 11:</b></label>
    <input type="file" accept="image/x-png,image/jpeg,image/jpg" style="display:none;"
    (change)="onselectFiletest($event,11,'')"  #file_uploadEleven>
    <!--<img style="height: 40px;width: 40px;"(click)="file_uploadEleven.click()" src="../../../assets/upload.png" class="uploadIcon"> -->
    <mat-label class="imageNav" (click)="file_uploadEleven.click()"><b>Offline Picture Upload</b></mat-label><br>
    <div><b>{{(cat11 != null) ? cat11['name']: '' }}</b>
     <button  [disabled] = "!internetstatus" *ngIf="cat11 && internetstatus" style="margin: 0 0 0 5px;padding: 4px;" class="btn btn-primary textsize" color="primary" type="button" (click)="submitImg(11)">Submit
     </button></div>
     </div><br>

    </div>
    <div class="d-flex justify-content-center">
    <mat-dialog-actions>
      <button class="btn btn-primary textsize" color="primary" type="button" (click)="ok();">Ok</button>&nbsp;&nbsp;
      <button class="btn btn-primary textsize" *ngIf="localStorageFlag" style="float:right;" type="button" (click)="clearStorage();">Remove Pictures</button>
    </mat-dialog-actions>
  </div>
  </div>

  `
})
export class PowerSupplyNameEditNetConnectDialog {
 onlineMessage;
  flag1:boolean = false;
  flag2:boolean = false;
  flag3:boolean = false;
  flag4:boolean = false;
  flag5:boolean = false;
  flag6:boolean = false;
  flag7:boolean = false;
  flag8:boolean = false;
  flag9:boolean = false;
  flag10:boolean = false;
  flag11:boolean = false;
  powerSupplyName: string = '';
  file: any;
  fileName: any;
  filearray : any [] = (localStorage.getItem('filearray')) ? JSON.parse(localStorage.getItem('filearray')) : [];
  detailedImage: any;
  activeMac: any;
  internetstatus: boolean;
  cat1: any;
  cat2: any;
  cat3: any;
  cat4: any;
  cat5: any;
  cat6: any;
  cat7: any;
  cat8: any;
  cat9: any;
  cat11: any;
  cat10: any;
  localStorageFlag: boolean = false;
  powerSupplyId: any;
  oldFlag: boolean = true;
  deleteFlag: boolean = false;
  confirmremovePic:boolean = false;

  private parent: PowerSupplyEditComponent;
  private powerSupplyMoveErrorDialog: MatDialogRef<PowerSupplyMoveErrorDialog>;
  private uploadDialog: MatDialogRef<UploadDialog>;

  public constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PowerSupplyNameEditNetConnectDialog>
  ) {
      this.activeMac = data.activeMac;
      this.parent = data.parent;
      this.powerSupplyId = data.powerSupplyId;
      this.powerSupplyName = this.data.powerSupplyName;

      this.createOnline$().subscribe((isOnline) => {
        if (isOnline) {
          this.internetstatus = true;
          this.onlineMessage = 'You are connected to internet';
        } else {
          this.internetstatus = false;
          this.onlineMessage = 'Network connectivity lost, please add pictures and complete upload upon reconnection';
        }
      });
      this.cat1 = JSON.parse(localStorage.getItem('cat1'))
      this.cat2 = JSON.parse(localStorage.getItem('cat2'))
      this.cat3 = JSON.parse(localStorage.getItem('cat3'))
      this.cat4 = JSON.parse(localStorage.getItem('cat4'))
      this.cat5 = JSON.parse(localStorage.getItem('cat5'))
      this.cat6 = JSON.parse(localStorage.getItem('cat6'))
      this.cat7 = JSON.parse(localStorage.getItem('cat7'))
      this.cat8 = JSON.parse(localStorage.getItem('cat8'))
      this.cat9 = JSON.parse(localStorage.getItem('cat9'))
      this.cat10 = JSON.parse(localStorage.getItem('cat10'))
      this.cat11 = JSON.parse(localStorage.getItem('cat11'))
      if(this.cat1 != null || this.cat2 != null || this.cat3 != null || this.cat4 != null || this.cat5 != null
        || this.cat6 != null || this.cat7 != null || this.cat8 != null || this.cat9 != null || this.cat10 != null
        || this.cat11 != null ){
        this.localStorageFlag = true;
      }
  }

  ok() {
    this.dialogRef.close('OK')
  }

  createOnline$() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

  onselectFiletest(event, uploadedId, imagedata){
   // if (event.target.files[0] !== null && event.target.files[0] !== undefined) {
    this.file = event.target.files[0];
    let fileBlob = null;
    if (this.file !== null && this.file !== undefined) this.fileName = this.file.name;
    var uploadId = uploadedId;
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (event: any) => {
      //let index = this.detailedImage.indexOf(imagedata);
      //imagedata.url = event.target.result;
     // this.detailedImage[index] = imagedata;
       if(uploadedId == 1){
         var blob = new Blob([this.file], { type: 'multipart/form-data' });
         fileBlob = new File([blob], this.fileName);
         const index = this.filearray.findIndex(obj => obj.id === uploadedId);
         if (index !== -1) { // only splice array when item is found
           this.filearray.splice(index, 1); // 2nd parameter means remove one item only
         }
         this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat1 =[];
        localStorage.removeItem('cat1');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat1',JSON.stringify(base64data));
        this.flag1 = true;
        this.cat1 = JSON.parse(localStorage.getItem('cat1'))
       }
       if(uploadedId == 2){
       var blob = new Blob([this.file], { type: 'multipart/form-data' });
       fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
       this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

       this.cat2 =[];
       localStorage.removeItem('cat2');
       let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
       localStorage.setItem('cat2',JSON.stringify(base64data));
       this.flag2 = true;
       this.cat2 = JSON.parse(localStorage.getItem('cat2'))
      }
      if(uploadedId == 3){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat3 =[];
        localStorage.removeItem('cat3');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat3',JSON.stringify(base64data));
        this.flag3 = true;
        this.cat3 = JSON.parse(localStorage.getItem('cat3'))
       }
       if(uploadedId == 4){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat4 =[];
        localStorage.removeItem('cat4');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat4',JSON.stringify(base64data));
        this.flag4 = true;
        this.cat4 = JSON.parse(localStorage.getItem('cat4'))
       }
       if(uploadedId == 5){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat5 =[];
        localStorage.removeItem('cat5');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat5',JSON.stringify(base64data));
        this.flag5 = true;
        this.cat5 = JSON.parse(localStorage.getItem('cat5'))
       }
       if(uploadedId == 6){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat6 =[];
        localStorage.removeItem('cat6');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat6',JSON.stringify(base64data));
        this.flag6 = true;
        this.cat6 = JSON.parse(localStorage.getItem('cat6'))
       }
       if(uploadedId == 7){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat7 =[];
        localStorage.removeItem('cat7');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat7',JSON.stringify(base64data));
        this.flag7 = true;
        this.cat7 = JSON.parse(localStorage.getItem('cat7'))
       }
       if(uploadedId == 8){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat8 =[];
        localStorage.removeItem('cat8');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat8',JSON.stringify(base64data));
        this.flag8 = true;
        this.cat8 = JSON.parse(localStorage.getItem('cat8'))
       }
       if(uploadedId == 9){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat9 =[];
        localStorage.removeItem('cat9');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat9',JSON.stringify(base64data));
        this.flag9 = true;
        this.cat9 = JSON.parse(localStorage.getItem('cat9'))
       }
       if(uploadedId == 10){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat10 =[];
        localStorage.removeItem('cat10');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat10',JSON.stringify(base64data));
        this.flag10 = true;
        this.cat10 = JSON.parse(localStorage.getItem('cat10'))
       }

       if(uploadedId == 11){
        var blob = new Blob([this.file], { type: 'multipart/form-data' });
        fileBlob = new File([blob], this.fileName);
        const index = this.filearray.findIndex(obj => obj.id === uploadedId);
        if (index !== -1) { // only splice array when item is found
          this.filearray.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });

        this.cat11 =[];
        localStorage.removeItem('cat11');
        let base64data = {id: uploadedId, name: this.fileName, base64: event.target.result};
        localStorage.setItem('cat11',JSON.stringify(base64data));
        this.flag11 = true;
        this.cat11 = JSON.parse(localStorage.getItem('cat11'))
       }
        //localStorage.removeItem('filearray');
        localStorage.setItem('filearray',JSON.stringify(this.filearray));
    }


   // }
  }

  submitImg(id){
    if(id == 1){
      let cat1 = localStorage.getItem('cat1')
      let parseData1 = JSON.parse(cat1)
      this.parent.psSingleFileUploadSubmit(parseData1.base64,parseData1.id,parseData1.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 2){
      let cat2 = localStorage.getItem('cat2')
      let parseData2 = JSON.parse(cat2)
      this.parent.psSingleFileUploadSubmit(parseData2.base64,parseData2.id,parseData2.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 3){
      let cat3 = localStorage.getItem('cat3')
      let parseData3 = JSON.parse(cat3)
      this.parent.psSingleFileUploadSubmit(parseData3.base64,parseData3.id,parseData3.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 4){
      let cat4 = localStorage.getItem('cat4')
      let parseData4 = JSON.parse(cat4)
      this.parent.psSingleFileUploadSubmit(parseData4.base64,parseData4.id,parseData4.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 5){
      let cat5 = localStorage.getItem('cat5')
      let parseData5 = JSON.parse(cat5)
      this.parent.psSingleFileUploadSubmit(parseData5.base64,parseData5.id,parseData5.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 6){
      let cat6 = localStorage.getItem('cat6')
      let parseData6 = JSON.parse(cat6)
      this.parent.psSingleFileUploadSubmit(parseData6.base64,parseData6.id,parseData6.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 7){
      let cat7 = localStorage.getItem('cat7')
      let parseData7 = JSON.parse(cat7)
      this.parent.psSingleFileUploadSubmit(parseData7.base64,parseData7.id,parseData7.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 8){
      let cat8 = localStorage.getItem('cat8')
      let parseData8 = JSON.parse(cat8)
      this.parent.psSingleFileUploadSubmit(parseData8.base64,parseData8.id,parseData8.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 9){
      let cat9 = localStorage.getItem('cat9')
      let parseData9 = JSON.parse(cat9)
      this.parent.psSingleFileUploadSubmit(parseData9.base64,parseData9.id,parseData9.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 10){
      let cat10 = localStorage.getItem('cat10')
      let parseData10 = JSON.parse(cat10)
      this.parent.psSingleFileUploadSubmit(parseData10.base64,parseData10.id,parseData10.name,this.activeMac,this.filearray,this.powerSupplyId)
    }
    if(id == 11){
      let cat11 = localStorage.getItem('cat11')
      let parseData11 = JSON.parse(cat11)
      this.parent.psSingleFileUploadSubmit(parseData11.base64,parseData11.id,parseData11.name,this.activeMac,this.filearray,this.powerSupplyId)
    }

  }

  noremovePicture(){
    this.confirmremovePic = false;
    this.oldFlag = true;
  }
  yesremovePicture(){
    this.confirmremovePic = false;
    setTimeout(() => {
      localStorage.removeItem('cat1');
      localStorage.removeItem('cat2');
      localStorage.removeItem('cat3');
      localStorage.removeItem('cat4');
      localStorage.removeItem('cat5');
      localStorage.removeItem('cat6');
      localStorage.removeItem('cat7');
      localStorage.removeItem('cat8');
      localStorage.removeItem('cat9');
      localStorage.removeItem('cat10');
      localStorage.removeItem('cat11');
      localStorage.removeItem('filearray');
      //this.dialog.closeAll()
      this.dialogRef.close();
      this.openErrorDialog("Stored Images are deleted successfully");
    });
  }

  clearStorage(){
    this.confirmremovePic = true;
    this.oldFlag = false;
  }

  openErrorDialog(message: string) {
    this.powerSupplyMoveErrorDialog = this.dialog.open(PowerSupplyMoveErrorDialog, {
      data: {
        message: message ? message : '',
      },
      disableClose: true
    })
    this.powerSupplyMoveErrorDialog.afterClosed().subscribe(res => res);
  }

  openUploadDialog(message: string) {
    this.uploadDialog = this.dialog.open(UploadDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.uploadDialog.afterClosed().subscribe(() => {});
  }


  noNewPicture(){
    this.deleteFlag = false;
    this.oldFlag = true;
  }

  yesNewPicture(){
    setTimeout(() => {
      this.deleteFlag = false;
    });
    localStorage.removeItem('cat1');
    localStorage.removeItem('cat2');
    localStorage.removeItem('cat3');
    localStorage.removeItem('cat4');
    localStorage.removeItem('cat5');
    localStorage.removeItem('cat6');
    localStorage.removeItem('cat7');
    localStorage.removeItem('cat8');
    localStorage.removeItem('cat9');
    localStorage.removeItem('cat10');
    localStorage.removeItem('cat11');
    localStorage.removeItem('filearray');
    this.cat1 = [];
    this.cat2 = [];
    this.cat3 = [];
    this.cat4 = [];
    this.cat5 = [];
    this.cat6 = [];
    this.cat7 = [];
    this.cat8 = [];
    this.cat9 = [];
    this.cat10 = [];
    this.cat11 = [];
    this.filearray = [];
    this.oldFlag = true;
    this.localStorageFlag = false;
  }

}
